import { createBrowserHistory } from 'history';

export const redirectTo = (exactPath: string):void => {
  const history = createBrowserHistory();

  return history.push(`${exactPath}`);
};
